// 会员单位申请
import request from '@/http/zhaocai'
const clUrl = process.env.VUE_APP_APIMATERIALS // 材料
const jxUrl = process.env.VUE_APP_APIMACHINERY // 机械
const sbUrl = process.env.VUE_APP_APIEQUIPMENT // 设备
const lgUrl = process.env.VUE_APP_LOGISTICS
const apiMember = {
  /* 材料 */
  getGoodsCategory: (data) => request.get(`${clUrl}/companyInfo/findItemCatByCompanyId`,data),
  getGoodsList: (data) => request.get(`${clUrl}/companyInfo/getCompanyItems`, data),

  /* 机械接口 */
  getAllCategory: () => request.get(`${jxUrl}/api/index/categoryList`),
  getRentInfo: (data) => request.get(`${jxUrl}/api/company/getCompanyList2`, data),

  /* 设备接口 */
  getSbAllCategory: () => request.get(`${sbUrl}/api/equipment/rentInfo/category`),
  getSbRentInfo: (data) => request.get(`${sbUrl}/equipment/rentInfo/memberRentList`,data),

  getModelSelect: (data) => request.get(`${sbUrl}/sysCar/Configure/modelSelect`,data),
  getGoodsTypeList :() => request.get(`${lgUrl}/goodsType/findCarLenList`),//货物类型

  getCarTypeByGoods: (no) => request.get(lgUrl + `/goodsType/carTypeByGoodsType?GoodsTypeNo=${no}`),
}
export default apiMember

